const { onlyAlphaNumeric } = require('../helpers');

const postcodeRegEx = /^([A-Z]{1,2}[0-9]{1,2}[A-Z]?)([0-9][A-Z]{2})$/i;
exports.zipCodeNormalize = (zipCode) => {
  if (!zipCode) {
    return zipCode;
  }
  const zip = onlyAlphaNumeric(zipCode).slice(0, 7);
  return zip.replace(postcodeRegEx, '$1 $2');
};

exports.countryDefinition = {
  country: 'Great Britain',
  code: 'GB',
  schema: {
    company: { label: 'Company' },
    address: { label: 'Address' },
    address2: { label: 'Address 2' },
    city: { label: 'City' },
    zipCode: { label: 'PostCode', normalize: exports.zipCodeNormalize }
  },
  viewFormat: [['company'], ['address'], ['address2'], ['city'], ['zipCode']],
  formFormat: [['company'], ['address'], ['address2'], ['city'], ['zipCode']],
  requiredFormFields: [
    { field: 'address' },
    { field: 'city' },
    {
      field: 'zipCode',
      validationRegex: new RegExp(postcodeRegEx),
      error:
        'Can be a variety of combinations such as: M2 5BQ, DN16 9AA, W1A 4ZZ'
    }
  ]
};
